// extracted by mini-css-extract-plugin
module.exports = {"text":"ae86d","link":"d3e21"};